import { render, staticRenderFns } from "./MobileNormPicker.vue?vue&type=template&id=4d71f069&lang=html&"
import script from "./MobileNormPicker.vue?vue&type=script&lang=js&"
export * from "./MobileNormPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d71f069')) {
      api.createRecord('4d71f069', component.options)
    } else {
      api.reload('4d71f069', component.options)
    }
    module.hot.accept("./MobileNormPicker.vue?vue&type=template&id=4d71f069&lang=html&", function () {
      api.rerender('4d71f069', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/MobileMenuComponents/MobileNormPicker.vue"
export default component.exports